/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { createGlobalStyle } from 'styled-components'
import { LocalStorage } from '../../utils/localStorage'
import LoginViewV2, { LoginViewV2Styles } from './login-widget/login/Containers/LoginViewV2'
import { ThemeType } from 'saur_ui_library/src/BrandsConfig';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import { colors } from 'saur_ui_library/src/Theme';

import LoginVisuel from '../../assets/login-visuel.svg';
import SaurIcon from '../common/Icon/SaurIcon';
import ResetStyleComponent from '../cssSaur/resetStyleComponent';
import { app_placeholder } from '../../env.placeholders';

const LoginPopup = () => {
    const [iframeVisible, setIframeVisible] = useState(false);

    useEffect(() => {
        const accessToken = JSON.parse(
            localStorage.getItem('sso-response') ?? 'null'
        )?.access_token
        if (!accessToken) {
            setIframeVisible(true)
        } else {
            const refreshToken = JSON.parse(
                localStorage.getItem('sso-response') ?? 'null'
            )?.refresh_token
            const roles = JSON.parse(
                localStorage.getItem('sso-response') ?? 'null'
            )?.roles
            LocalStorage.token.set(accessToken)
            LocalStorage.refreshToken.set(refreshToken)
            LocalStorage.userRole.set(roles)
        }
    }, []);

    return (
        <Container className='sds-reset-style LoginScreen' automatedTestId='login-screen'>
            <ResetStyleComponent />
            <Styles />
            {iframeVisible && <>
            <Container className='LoginScreen-main-content'>
                <Container className='LeftPanelRow'>
                    <Container className='LeftPanel'>
                        <Container className='leftpanel-top-content'>
                            <Container className='logo-saur'>
                                <SaurIcon content="login" color={colors.white}></SaurIcon>
                            </Container>
                            <Container className='LeftPanelContainerTitle'>
                                <Word
                                    className='LeftPanelTitle'
                                    value='Bienvenue sur Diag 360'
                                    textStyle='titleSemiLarge'
                                    variant='h1'
                                />
                            </Container>
                            <Container className='LeftPanelDescWord'>
                                <Word
                                    value="Cet espace, dédié à votre contrat d'assainissement, 
                                    permet de suivre la cohérence et complétude des données des installations d'assainissement, 
                                    l'évolution des différents volets du diagnostic permanent sur vos systèmes, 
                                    et de consulter les tableaux de bord correspondants."
                                    textStyle='normalReg'
                                    variant='p'
                                />
                                <Word
                                    value='Vous n’avez pas encore de compte ? 
                                    Nous vous invitons à contacter votre interlocuteur SAUR habituel.'
                                    textStyle='normalReg'
                                    variant='p'
                                />
                            </Container>
                        </Container>
                        <img
                            alt=''
                            className='LeftPanelIllustration'
                            src={LoginVisuel}
                        />
                    </Container>
                </Container>
                <Container className='RightPanelRow'>
                    <Container className='RightPanel'>
                        <Container className='RightPanelContent'>
                            <Container className='login-widget-V2'>
                                <LoginViewV2
                                    realm={app_placeholder.VITE_APP_REALM_KEYCLOAK ?? ''}
                                    clientIdIntern='DiagPermWeb'
                                    idpUrl={app_placeholder.VITE_APP_URL_KEYCLOAK ?? ''}
                                    titleLabel='Connexion'
                                    loginBtnLabel='Me connecter'
                                    inputTitleLabel='Identifiant'
                                    inputPlaceholderLabel='Votre email'
                                />
                            </Container>
                        </Container>
                        <Container className='RightPanelFooter'>
                            <Word
                                className='AppVersion'
                                value={`Version ${import.meta.env.VITE_APP_VERSION ?? '—'} (${(import.meta.env.VITE_APP_COMMIT_SHA ?? '—').slice(0, 7)}) · ${import.meta.env.VITE_APP_BRANCH ?? '—'} · ${import.meta.env.VITE_APP_BUILD_TIME ?? '—'}`}
                                textStyle='tinyRegular'
                                variant='span'
                            />
                        </Container>
                    </Container>
                </Container>
            </Container></>}
        </Container>
    )
}
const Styles = createGlobalStyle`
    .LoginScreen {
        height: 100vh;
        .LoginScreen-main-content {
            flex: 1;
            flex-direction: row;
            align-items: stretch;
            display: ruby;
            .LeftPanelContainerTitle {
                justify-content: center;
                align-items: center;
            }
        .LeftPanelRow {
            position: relative;
            background-color: ${(props: ThemeType) =>
                props.theme.colors.primaryLight};
            width: 50%;
            height: auto;
        }
        .LeftPanel {
            .leftpanel-top-content {
                .logo-saur {
                    justify-content: center;
                    align-items: center;
                    .sds-saur-icon-container.login {
                        width: 216px;
                        height: 150px;
                    }
                }
                padding-top: 7%;
                .LeftPanelTitle {
                    margin-top: 7%;
                    width: 50%;
                    flex-direction: column;
                }
                .LeftPanelDescWord {
                    margin: 4% 0;
                }
            }
            flex: 1;
            align-self: stretch;
            background-color: ${(props: ThemeType) =>
                props.theme.colors.primaryDark};
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            border-bottom-left-radius: 0px;
        }
        .LeftPanelTitle {
            text-align: center;
            color: ${(props: ThemeType) => props.theme.texts.lightColor};
            &:first-child {
                margin-bottom: 10px;
            }
        }
        .LeftPanelDescWord {
            padding: 0 17%;
            color: ${(props: ThemeType) => props.theme.texts.lightColor};
        }
        .LeftPanelIllustration {
            width: calc(79% - 40px);
        }
        .RightPanelRow {
            position: fixed;
            align-items: stretch;
            width: 50%;
            height: 60vh;
            left: 50%;
            top: 30vh;
        }
        .RightPanel {
            flex: 1;
            align-self: stretch;
            padding: 0 8%;
            border-top-right-radius: 0px;
            border-top-left-radius: 60px;
        }
        .RightPanelContent {
            flex: 1;
            justify-content: center;
            padding: 20px 0;
            .login-widget-V2{
                ${LoginViewV2Styles}
                .login-screen-loading {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 200px;
                }
            }
        }
        .ImageBadge {
            width: 90px;
            height: 44px;
            &:first-child {
                margin: 0 30px;
            }
        }
        .RightPanelFooter { 
            flex-direction: row;
            margin-bottom: 8%;
            align-items: center;
            justify-content: center;
            .AppVersion {
                color: ${colors.grey};
                font-size: 12px;
            }
        }
        .BadgesContainer {
            flex-direction: row;
            align-self: flex-end;
            justify-content: center;
        }
        }

        .LoginScreen-disco-modal {
            .card-header {
                display: none;
            }
        }
        .o-form-input-error, .infobox-error p {
            color: red;
        }

        .LeftPanelDescWord p {
            padding: 10px 0;
            color: ${colors.white};
        }
    }
`;
export default LoginPopup;
